import React from 'react'

import './index.scss'
import { Thumbnail, WidthWrapper } from 'components'

import illustrationFallingWoman from '../../../../assets/images/svg/illustration-falling-woman.svg'

const Error500 = () => {
  return (
    <div className="error-500">
      <WidthWrapper className="wrapper">
        <div className="text">
          <div>
            <h1>Oops,</h1>
            <p>something went wrong!</p>
            <p className="sub-text">Please try again later.</p>
          </div>
        </div>
        <Thumbnail className="image" src={illustrationFallingWoman} />
      </WidthWrapper>
    </div>
  )
}

export default Error500
